<template>
  <div class="aksi">
    <button
      ref="pemicuRef"
      type="button"
      class="button button-primary aksi__pemicu"
      :aria-expanded="terbuka"
      aria-haspopup="menu"
      @click.stop="alihkan"
    >
      <i class="bi bi-card-checklist" aria-hidden="true"></i>
      <span>{{ label }}</span>
      <i class="bi bi-chevron-down aksi__panah" aria-hidden="true"></i>
    </button>

    <!--
      Menu dipindahkan ke <body> lewat Teleport.
      Kalau dibiarkan di dalam tabel, ia terpotong oleh `overflow` yang
      dipasang pada wadah tabel agar bisa digeser di ponsel. Teleport
      mengeluarkannya dari konteks pemotongan itu sepenuhnya.
    -->
    <Teleport to="body">
      <div
        v-if="terbuka"
        ref="menuRef"
        class="aksi__menu"
        role="menu"
        :style="gaya"
        @click.stop
      >
        <slot :tutup="tutup" />
      </div>
    </Teleport>
  </div>
</template>

<script>
/**
 * Menu "Aksi" untuk baris tabel admin.
 *
 * Seluruh logika posisi, pembalikan ke atas, dan penutupan otomatis ada di
 * useMenuMengambang — dipakai bersama ThemeToggle dan LanguageSwitcher.
 * Sebelumnya logika itu ditulis ulang di sini, dan hanya versi di berkas
 * inilah yang menangani pembalikan ke atas; dua komponen lain tidak,
 * sehingga menunya keluar layar di footer.
 */
import { useMenuMengambang } from '@/composables/useMenuMengambang';

export default {
  name: 'MenuAksi',

  props: {
    label: { type: String, default: 'Aksi' },
  },

  setup() {
    return useMenuMengambang({ lebarMinimal: 190 });
  },
};
</script>

<style scoped>
.aksi { display: inline-block; }

.aksi__pemicu {
  gap: var(--space-2);
  min-height: 32px !important;
  padding: 0.3rem 0.65rem !important;
  font-size: 0.8125rem !important;
  border-radius: var(--radius-sm, 6px) !important;
}
.aksi__panah { font-size: 0.65rem; opacity: 0.75; }
</style>

<style>
/*
 * TIDAK scoped: menu dipindahkan ke <body> lewat Teleport, sehingga berada
 * di luar jangkauan atribut data-v milik komponen ini.
 */
.aksi__menu {
  position: fixed;
  z-index: 1080;
  min-width: 190px;
  padding: var(--space-1);
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
}

.aksi__menu .aksi__item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
  min-height: 42px;
  padding: var(--space-2) var(--space-3);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: 600;
  text-align: left;
  text-decoration: none;
  color: var(--text-secondary);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.aksi__menu .aksi__item:hover,
.aksi__menu .aksi__item:focus-visible {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.aksi__menu .aksi__item--bahaya { color: var(--danger-600); }
.aksi__menu .aksi__item--bahaya:hover { background: rgb(220 38 38 / 0.10); }
</style>
